import { useEffect, useState } from 'react';
import { ANG_APIS } from '../../api.constants';
import { useParams } from 'react-router-dom';
import CommonAddContact from '../common/CommonAddContact';
import APIService from '../../../Services/APIService';

export default function BasicDetailsGym() {
  const { id } = useParams();
  const [vendors, setVendors] = useState();
  const [details, setDetails] = useState();
  const [formData, setFormData] = useState();
  const initialContactForm = {
    alternate_number: null,
    city: null,
    comments: null,
    contact_authority: null,
    contact_type: '',
    content_type: null,
    country_code: null,
    created_at: '',
    department: null,
    designation: null,
    email: '',
    landline: null,
    level_of_management: null,
    linkedin_id: null,
    mobile: null,
    name: '',
    object_id: '',
    other_contact_type: null,
    relationship_status: null,
    salutation: '',
    specify_others: null,
    spoc: null,
    std_code: null,
    updated_at: '',
  };

  const getOrganizations = async () => {
    let res = await APIService.get(ANG_APIS.GET_ORGANIZATIONS);
    if (res.status == 200) setVendors(res.data);
  };

  const getDetails = async () => {
    let res = await APIService.get(`${ANG_APIS.GET_LIST_GENERIC}${id}/?supplier_type_code=GY`)
    if (res) {
      setDetails(res.data);
      setFormData(res.data);
    };
  };

  useEffect(() => {
    getOrganizations();
    getDetails();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;
    setFormData(data);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let res = await APIService.put(`${ANG_APIS.GET_LIST_GENERIC}${id}`, formData);
    if (res.status == 200) alert('Done');
  };

  const handleAddContact = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contactData: [...prevFormData.contactData, initialContactForm],
    }));
  };

  return (
    <>
      <div className="panel-default panel-container">
        <label style={{ color: '#3c763d' }}>Representative :</label>
        <select
          className="form-control"
          ng-model="representativeField.name"
          ng-change="setVendor()"
        >
          <option value="" disabled>
            Select Representative/Principal Vendor
          </option>
          {vendors &&
            vendors.map((vendor, key) => {
              return (
                <option key={key} value={vendor.name} ng-repeat="vendor in vendorData">
                  {vendor.name}
                </option>
              );
            })}
        </select>
        <br />
        <form className="form-inline" role="form" name="gym_form" onSubmit={handleSubmit}>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="supplier_id">Gym ID</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="supplier_id"
              placeholder="Gym ID"
              value={details?.supplier_id}
              disabled
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="supplier_name">Name</label>
            <br />
            <input
              type="text"
              disabled
              className="form-control"
              id="supplier_id"
              value={details?.name}
              placeholder="Name"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="address1">
              Address1<sup>*</sup>
            </label>
            <br />
            <input
              type="text"
              className="form-control"
              id="address1"
              name="master_data.address_supplier.address1"
              value={formData?.master_data?.address_supplier?.address1}
              onChange={handleChange}
              placeholder="Address1"
              required
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="address2">Address2</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="address2"
              value={details?.master_data.address_supplier.address2}
              placeholder="Address2"
            />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="locality">Locality</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="locality"
              value={details?.master_data.address_supplier.area}
              placeholder="Locality"
              disabled
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="locality">Sub Area</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="subarea"
              value={details?.master_data.address_supplier.subarea}
              placeholder="Sub Area"
              disabled
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="city">City</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="city"
              value={details?.master_data.address_supplier.city}
              disabled
              placeholder="City"
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="state">State</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="state"
              value={details?.master_data.address_supplier.state}
              placeholder="State"
              disabled
              readonly
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="zipcode">Zip Code</label>
            <br />
            <input
              type="number"
              name="zip_code"
              className="form-control"
              id="zipcode"
              value={details?.master_data.address_supplier.zipcode}
              ng-pattern="/^[0-9]{6}$/"
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
              placeholder="Zip Code"
            />
            {/* <div
              ng-show="corporate_form.zip_code.$error.pattern"
              className="error"
              style={{ fontSize: '12px' }}
            >
              Please enter 6 digit positive numbers only
            </div> */}
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="latitude">Latitude*</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="latitude"
              value={details?.master_data.address_supplier.latitude}
              placeholder="Latitude"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="longitude">Longitude*</label>
            <br />
            <input
              type="text"
              className="form-control"
              id="longitude"
              value={details?.master_data.address_supplier.longitude}
              placeholder="Longitude"
            />
          </div>
          <div className="col-md-12" style={{ marginLeft: '-15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Categorization</h3>
            </label>
            <br />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>
              Gym Type<sup>*</sup>
            </label>
            <br />

            <select className="form-control" required>
              <option value="" disabled>
                Select Gym Type
              </option>
              <option ng-repeat="gym_type in gymtypelist" value="gym">
                Gym
              </option>
              <option ng-repeat="gym_type in gymtypelist" value="club">
                Club
              </option>
            </select>
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Chain/Individual</label>
            <br />
            <select className="form-control">
              <option value="" disabled>
                Select Chain/Individual{' '}
              </option>
              <option ng-repeat="item1 in chainlist" value="chain">
                Chain
              </option>
              <option ng-repeat="item1 in chainlist" value="individual">
                Individual
              </option>
            </select>
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="origin">Chain Origin</label>
            <br />
            <input
              type="text"
              placeholder="Chain Origin"
              className="form-control"
              id="origin"
              value={details?.chain_origin}
            />
          </div>

          <br />
          <br />
          <div className="col-md-12" style={{ marginLeft: '-15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Counts and Ratings</h3>
            </label>
            <br />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="footfall_day">Weekday Daily Footfall Count</label>
            <br />
            <input
              type="number"
              className="form-control"
              placeholder="Weekday Daily Footfall Count"
              id="footfall_day"
              value={details?.master_data.unit_secondary_count}
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="footfall_weekend">Weekend Daily Footfall Count</label>
            <br />
            <input
              type="number"
              className="form-control"
              placeholder="Weekend Daily Footfall Count"
              id="footfall_weekend"
              value={details?.master_data.unit_primary_count}
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="membership_count">Membership Count</label>
            <br />
            <input
              type="number"
              className="form-control"
              id="membership_count"
              placeholder="Membership Count"
              value={details?.master_data.unit_tertiary_count}
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Gym Rating</label>
            <br />
            <select className="form-control" value={details?.category}>
              <option value="" disabled>
                Select Gym Rating{' '}
              </option>
              <option ng-repeat="cat in categorylist" value="{{cat}}">
                {/* {{ cat }} */}
              </option>
            </select>
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Locality Rating</label>
            <br />
            <select className="form-control">
              <option value="" disabled>
                Select Locality Rating{' '}
              </option>
              <option ng-repeat="lrating in localityratinglist" value="{{lrating}}">
                {/* {{ lrating }} */}
              </option>
            </select>
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="area">Machadalo Index</label>
            <br />
            <input
              type="number"
              placeholder="Machadalo Index"
              className="form-control"
              id="mdindex"
              value={details?.machadalo_index}
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
              disabled
            />
          </div>

          <br />
          <br />
          <div className="col-md-12" style={{ marginLeft: '-15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Other Details</h3>
            </label>
            <br />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Current Advertising Media</label>
            <br />
            <input
              type="text"
              placeholder="Current Advertising Media"
              className="form-control"
              value={details?.advertising_media}
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Diet Chart/Workout Planner(6 months)</label>
            <br />
            <input
              type="number"
              placeholder="Diet Chart"
              className="form-control"
              value={details?.dietchart_price}
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label for="membership">Total Membership/Annum</label>
            <br />
            <input
              type="number"
              placeholder="Total Membership/Annum"
              className="form-control"
              id="membership"
              value={details?.totalmembership_perannum}
              onkeydown="javascript: return event.keyCode == 69 ? false : true"
            />
          </div>

          <br />
          <br />

          <div className="col-md-12" style={{ marginLeft: '-15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Payment Details</h3>
            </label>
            <br />
          </div>

          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Gym Name</label>
            <br />
            <input
              type="text"
              placeholder="Gym Name"
              className="form-control"
              ng-model="ownership_details.bank_account_name"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Bank Name</label>
            <br />
            <input
              type="text"
              placeholder="Bank Name"
              className="form-control"
              ng-model="ownership_details.bank_name"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>IFSC Code</label>
            <br />
            <input
              type="text"
              placeholder="IFSC Code"
              className="form-control"
              ng-model="ownership_details.ifsc_code"
            />
          </div>
          <div className="form-group col-md-3" style={{ marginBottom: '20px' }}>
            <label>Account Number</label>
            <br />
            <input
              type="text"
              placeholder="Account Number"
              className="form-control"
              ng-model="ownership_details.account_number"
            />
          </div>

          <h2 className="heading">Contact Details</h2>
          <div className="col-md-12" style={{ marginLeft: -'15px' }}>
            <label for="temp" style={{ marginLeft: '0px' }}>
              <h3>Contact Details</h3>
            </label>
            <br />
          </div>
          <CommonAddContact formData={formData} setFormData={setFormData} />
          <input
            onClick={handleAddContact}
            type="button"
            className="smallBtn"
            value="Add"
            ng-click="addNewContact()"
          />
          <br />
          <br />
          <div className="bottomButtonBox">
            <button type="submit" className="smallBtn">
              Update Gym
            </button>
          </div>
        </form>
      </div>
    </>
  );
}
